var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.setting.options),function(option){return _c('button',{key:option,attrs:{"disabled":_vm.setting.value === option},on:{"click":function($event){return _vm.select(option)}}},[_vm._v(" "+_vm._s(option)+" ")])}),_c('label',[_vm._v(_vm._s(_vm.setting.displayName))])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }